import { useEffect, useRef, useState } from 'react';

export enum CashPaymentStatus {
  INITIATED = 'INITIATED',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  CAPTURED = 'CAPTURED',
  FAILED = 'FAILED',
}

export const useCashPaymentStatus = () => {
  const [cashPaymentStatus, setCashPaymentStatusState] = useState<CashPaymentStatus | undefined>(undefined);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);
  const storageKey = 'cash_payment_status';

  const setCashPaymentStatus = (status: CashPaymentStatus) => {
    sessionStorage.setItem(storageKey, status);
    setCashPaymentStatusState(status);
  };

  const clearCashPaymentStatus = () => {
    sessionStorage.removeItem(storageKey);
    setCashPaymentStatusState(undefined);
  };

  const checkSessionStorage = () => {
    const newValue = sessionStorage.getItem(storageKey);
    const newCashPaymentStatus = newValue ? (newValue as CashPaymentStatus) : undefined;
    if (newCashPaymentStatus !== cashPaymentStatus) {
      setCashPaymentStatusState(newCashPaymentStatus);
    }
  };

  const startMonitoring = () => {
    if (!intervalIdRef.current) {
      checkSessionStorage();
      intervalIdRef.current = setInterval(checkSessionStorage, 3000);
    }
  };

  const stopMonitoring = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  };

  useEffect(() => () => stopMonitoring(), []);

  return { cashPaymentStatus, clearCashPaymentStatus, setCashPaymentStatus, startMonitoring, stopMonitoring };
};
